import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { UtilService } from '../services/util.service';
import { ProctorService } from '../services/proctor.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-second-view-iframe',
  templateUrl: './second-view-iframe.component.html',
  styleUrls: ['./second-view-iframe.component.css']
})
export class SecondViewIframeComponent implements AfterViewInit {
  @ViewChild('secondViewIframe') secondViewIframe!: ElementRef;

  constructor(private util: UtilService, private proctorService: ProctorService){

  }

  ngAfterViewInit(): void {
    this.secondViewIframe.nativeElement.src = `//${this.proctorService.getCompany()}.${environment.secondViewProctorDomain}/secondview?interactive=false`
  }
  


}
